import React from 'react';
import Translate from '../../components/Translate';

export var getKycStatus = function getKycStatus(status) {
  var translations = {
    New: React.createElement(Translate, { id: 'label.kyc-status-new', defaultMessage: 'New' }),
    Approved: React.createElement(Translate, { id: 'label.kyc-status-approved', defaultMessage: 'Approved' }),
    Declined: React.createElement(Translate, { id: 'label.kyc-status-declined', defaultMessage: 'Declined' })
  };

  return translations[status] || React.createElement(
    'span',
    null,
    status
  );
};